<template>
  <div class="faq">
    <h2 class="section-title">{{$t("notes")}}</h2>
    <div  :class="'faq-cc'" @click="questionClick(index)"  v-for="(item,index) in question" :key="index">
      <div class="faq-c">
        <div class="faq-index">{{(index+1)}}</div>
        <div class="faq-content">{{item.content}}</div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "faq",
  data(){
    return{
      questionA:'',
      question:[
        {title:this.$t('whatIsCopyTrading'),isShow:false,content:this.$t('signal_provider_rules_1')},
        {title:this.$t('howCopyTradingWorks'),isShow:false,content:this.$t('signal_provider_rules_2')},
        {title:this.$t('whatIsAum'),isShow:false,content:this.$t('signal_provider_rules_3')},
        {title:this.$t('leaderRewards'),isShow:false,content:this.$t('signal_provider_rules_4')},
        {title:this.$t('leaderRewards'),isShow:false,content:this.$t('signal_provider_rules_5')},
        {title:this.$t('leaderRewards'),isShow:false,content:this.$t('signal_provider_rules_6')},
        {title:this.$t('leaderRewards'),isShow:false,content:this.$t('signal_provider_rules_7')},
        {title:this.$t('leaderRewards'),isShow:false,content:this.$t('signal_provider_rules_8')},
      ],
    }
  },
  methods:{
    questionClick(n) {
      this.question[n].isShow = !this.question[n].isShow
    },
    refresh(){
      this.question=[
        {title:this.$t('whatIsCopyTrading'),isShow:false,content:this.$t('copyTradingDescription')},
        {title:this.$t('howCopyTradingWorks'),isShow:false,content:this.$t('copyTradingProcess')},
        {title:this.$t('whatIsAum'),isShow:false,content:this.$t('aumDefinition')},
        {title:this.$t('leaderRewards'),isShow:false,content:this.$t('leaderRewardsDescription')}
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.bg{
  background: #0B0E11;
  border-radius: 10px;
}
.faq-cc{
  margin-top: 38px;
}

.faq-c{
  display: flex;
  align-items: center;
  gap: 32px;
  padding-left: 34px;
  padding-right: 34px;
  .faq-index{
    width: 32px;
    height: 32px;
    border-radius: 6px;
    text-align: center;
    line-height: 32px;
    border: 1px solid rgba(234, 236, 239, 0.3);
  }
  .faq-content{
    font-size: 16px;
    flex: 1;
    font-weight: 400;
    letter-spacing: 0px;
    color: rgba(234, 236, 239, 0.5);
  }
}

@media (max-width: 750px) {
  .faq-cc{
    margin-top: 0px;
  }
  .faq-c{
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 16px;
    .faq-index{
      width: 17px;
      height: 17px;
      border-radius: 4px;
      text-align: center;
      line-height: 17px;
      border: 1px solid rgba(234, 236, 239, 0.3);
    }
    .faq-content{
      font-size: 11px;
      flex: 1;
      font-weight: 400;
      letter-spacing: 0px;
      color: rgba(234, 236, 239, 0.5);
    }
  }
}



</style>
